import moment from 'moment-timezone'

import {
  TIMEZONE,
  TIME_LIMIT,
  NEXT_SERVICE_DAY_BEFORE_TIME_LIMIT,
  NEXT_SERVICE_DAY_AFTER_TIME_LIMIT
} from '@src/globals'

export function getNextServiceDate () {
  const now = moment().tz(TIMEZONE)
  const todayAtTimeLimit = now.clone().hour(TIME_LIMIT).startOf('hour')

  return now.isBefore(todayAtTimeLimit)
    ? now.add(NEXT_SERVICE_DAY_BEFORE_TIME_LIMIT, 'days').startOf('day')
    : now.add(NEXT_SERVICE_DAY_AFTER_TIME_LIMIT, 'days').startOf('day')
}



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/DateTimeForm/utils.js